import { MultiChoiceCard } from '@/models'

export type RevokeScenario = 'blank_unassigned' | 'preissue_assigned' | 'dynamic_assigned'

export function getRevokeScenario(card: MultiChoiceCard, preIssue: boolean): RevokeScenario {
  if (!card.customer?.id) return 'blank_unassigned'
  if (preIssue) return 'preissue_assigned'
  return 'dynamic_assigned'
}

export function getRevokeDescriptionKey(scenario: RevokeScenario): string {
  switch (scenario) {
    case 'blank_unassigned':
      return 'gifts.revokeDialog.descriptionBlankUnassigned'
    case 'preissue_assigned':
      return 'gifts.revokeDialog.descriptionPreIssueAssigned'
    case 'dynamic_assigned':
      return 'gifts.revokeDialog.descriptionDynamicAssigned'
  }
}

export function getRevokeEmailWarningKey(scenario: RevokeScenario): string {
  switch (scenario) {
    case 'preissue_assigned':
      return 'gifts.revokeDialog.emailWarningPreIssue'
    case 'dynamic_assigned':
      return 'gifts.revokeDialog.emailWarningDynamic'
    default:
      return 'gifts.revokeDialog.emailWarningPreIssue'
  }
}

export function getBulkRevokeDescriptionKey(cards: MultiChoiceCard[], preIssue: boolean): string {
  const scenarios = new Set(cards.map(card => getRevokeScenario(card, preIssue)))
  if (scenarios.size === 1) {
    return getRevokeDescriptionKey([...scenarios][0])
  }
  return 'gifts.revokeBulkDialog.descriptionMixed'
}
